import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { ErrorData, MessageService } from 'src/app/services/message/message.service';
import { PublicacaoService } from 'src/app/services/publicacao/publicacao.service';
import { RegiaoService } from 'src/app/services/regiao/regiao.service';
import { Subscription } from 'rxjs';
import { Distribuidor, OfertaCliente, Publicacao } from 'src/models/interfaces/publicacao/publicacao-interface';
import { DatePipe } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { HomeComponent } from '../../home/home.component';
import { EmpresaService } from 'src/app/services/register-data/empresa/empresa.service';
import { ContratoService } from 'src/app/services/contrato/contrato.service';
import { ConsultarTermoFidelidade, ContratoVolume } from 'src/models/interfaces/contrato/contrato.interface';
import { base64ToBlob } from 'src/utils/blob';
import { getDateBrasil } from 'src/utils/getDate';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';

@Component({
  selector: 'spe-quadro-de-avisos',
  templateUrl: './quadro-de-avisos.component.html',
  styleUrls: ['./quadro-de-avisos.component.scss'],
  providers: [DatePipe],
  standalone: false
})
export class QuadroDeAvisosComponent implements OnInit, OnDestroy {
  apiStatus: string | null = null;
  message: string = '';

  listRegions: Distribuidor[] = [];

  listPublicacoesFiltradas: Publicacao[] = [];
  listPublicacoesGrupoFiltradas: Publicacao[] = [];
  listLength = 10;

  showButton = true;

  subscriptions: Subscription[] = [];

  regiaoForm = new FormGroup({
    regiao: new FormControl(0)
  });

  groupForm = new FormGroup({
    grupo: new FormControl<number | string | null>(1),
    chips: new FormControl(['Empresa'])
  });

  avisosCadadastrosIncompletos: any[] = [];
  showAvisosCadastrosIncompletos: boolean = false;
  showAvisoTermosDeContrato: boolean = false;
  termosFidelidade: ConsultarTermoFidelidade[] = [];
  showTermoFidelidade: boolean = false;
  volumesContratados: ContratoVolume[] = [];
  idPublicacaoTermoFidelidade: number = 0;
  showPublicacaoAceitavelBanner: boolean = false;
  idPublicacaoAceitavelBanner: number = 0;
  showTermoFidelidadePremmiar: boolean = false;
  idPublicacaoTermoPremmiar: number = 0;
  configuracoesOfertaImagem: OfertaCliente[] = [];
  public sigla = localStorage.getItem('sigla');
  public site = localStorage.getItem('site');
  public grupo = JSON.parse(localStorage.getItem('grupoCliente')!);
  public readonly displayedColumns: string[] = ['data', 'titulo', 'icone'];
  public dataSource = new MatTableDataSource<Publicacao>([]);
  @ViewChild(MatSort) set matSort(sort: MatSort) {
    this.dataSource.sort = sort;
  }
  @ViewChild(MatPaginator) paginator!: MatPaginator;

  constructor(
    private messageService: MessageService,
    private publicacaoService: PublicacaoService,
    private datePipe: DatePipe,
    private activatedRoute: ActivatedRoute,
    private homeComponent: HomeComponent,
    private empresaService: EmpresaService,
    private contratoService: ContratoService,
    private regiaoService: RegiaoService,
    public routerService: Router
  ) {}

  toggleKeyword(keyword: string, event: any) {
    if (keyword == 'Empresa') {
      this.groupForm.controls.grupo.setValue(1);
    } else if (keyword == 'Grupo') {
      this.groupForm.controls.grupo.setValue(2);
    }
  }

  ngOnInit() {
    this.homeComponent.menuName = '';
    this.getTermoPremmiar();
    this.getOfertas(23, 'S', 'N');
    this.getPrimeiraPublicacaoAceitavel();
    this.getPublicacaoAceitavelBanner();
    this.getTermosFidelidade();
    this.setPageTitle();
    this.getPublicacoes(0, 1);
    this.subscribeMessageService();
    this.subscribeFilters();
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
  }

  ngOnDestroy() {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }

  getTermosFidelidade() {
    this.contratoService.getVolumes().subscribe({
      next: (response) => {
        this.volumesContratados = response;
      }
    });
    this.contratoService.consultarTermosFidelidade().subscribe({
      next: (response) => {
        this.termosFidelidade = response;
        if (response.length > 0) {
          this.showAvisoTermosDeContrato = true;
        }
      }
    });
  }

  getPrimeiraPublicacaoAceitavel() {
    this.publicacaoService.primeiraAceitavel(18).subscribe({
      next: (resp) => {
        if (resp && resp.id) {
          const dataFinal = new Date(resp.dataFinal);
          const dataInicial = new Date(resp.dataInicial);
          const dataAtual = getDateBrasil();

          if (dataAtual >= dataInicial && dataAtual <= dataFinal) {
            this.idPublicacaoTermoFidelidade = resp.id;
            this.showTermoFidelidade = true;
          }
        }
      }
    });
  }

  getPublicacaoAceitavelBanner() {
    this.publicacaoService.primeiraAceitavel(40).subscribe({
      next: (resp) => {
        if (resp && resp.id) {
          const dataFinal = new Date(resp.dataFinal);
          const dataInicial = new Date(resp.dataInicial);
          const dataAtual = getDateBrasil();

          if (dataAtual >= dataInicial && dataAtual <= dataFinal) {
            this.idPublicacaoAceitavelBanner = resp.id;
            this.showPublicacaoAceitavelBanner = true;
          }
        }
      }
    });
  }

  setPageTitle() {
    this.activatedRoute.params.subscribe((response) => {
      this.homeComponent.idleMenuContent = [];
      if (response.status === 'inicial') {
        this.getCadastrosIncompletos();
      } else {
        this.homeComponent.iconPath = 'assets/images/64_icon_presentation.png';
        this.homeComponent.setNewVariables(
          'Notificações',
          'Mantenha-se informado sobre os benefícios através dos comunicados inseridos no quadro de avisos.'
        );
      }
    });
  }

  get isGrupo() {
    return this.grupo?.length > 1;
  }

  getCadastrosIncompletos() {
    const subscription = this.empresaService.getCadastrosIncompletos().subscribe({
      next: (cadastros) => {
        for (const [key, value] of Object.entries(cadastros)) {
          if (!value) {
            continue;
          }
          this.homeComponent.showAvisosCadastrosIncompletos = true;
          switch (key) {
            case 'precisaAtualizarInscricaoEstadual':
              this.avisosCadadastrosIncompletos.push({
                sigla: 'IE',
                avisoPart1: 'Existem Inscrições Estaduais que precisam ser atualizadas. ',
                avisoPart2: ' para resolver.'
              });
              break;
            case 'precisaAtualizarInscricaoMunicipal':
              this.avisosCadadastrosIncompletos.push({
                sigla: 'IM',
                avisoPart1: 'Existem Inscrições Municipais que precisam ser atualizadas. ',
                avisoPart2: ' para resolver.'
              });
              break;
            case 'precisaAtualizarEnderecoDeFaturamento':
              this.avisosCadadastrosIncompletos.push({
                sigla: 'END',
                avisoPart1: 'Existem Endereços de Faturamento que precisam ser atualizadas. ',
                avisoPart2: ' para resolver.'
              });
              break;
          }
        }
        this.homeComponent.avisosCadadastrosIncompletos = this.avisosCadadastrosIncompletos;
      }
    });
    this.subscriptions.push(subscription);
  }

  getPublicacoes(regiao: number, tipo: number) {
    const subscription = this.publicacaoService
      .listaPublicacoesByCliente(regiao ?? 0, parseInt(localStorage.getItem('idParceriaLogin')!), tipo)
      .subscribe({
        next: (data) => {
          if (data) {
            if (regiao === 0) {
              this.listRegions = data.distribuidores;
            }
            this.listPublicacoesFiltradas = data.publicacoes;
            this.dataSource.data = data.publicacoes;
          }
        }
      });

    this.subscriptions.push(subscription);
  }

  subscribeFilters() {
    this.regiaoForm.controls.regiao.setValue(0);
    const subscriptionRegion = this.regiaoForm.controls[`regiao`].valueChanges.subscribe({
      next: (regiao) => {
        const grupo = this.groupForm.controls[`grupo`].value;

        this.getPublicacoes(regiao || 0, grupo as number);
        this.listLength = 10;
      }
    });
    this.subscriptions.push(subscriptionRegion);

    const subscriptionGroup = this.groupForm.controls[`grupo`].valueChanges.subscribe({
      next: (grupo) => {
        this.regiaoForm.controls.regiao.setValue(0, { emitEvent: false });
        this.listLength = 10;
        if (grupo == 1) {
          this.getPublicacoes(0, 1);
        } else {
          this.getPublicacoes(0, 2);
        }
      }
    });
    this.subscriptions.push(subscriptionGroup);
  }

  getPublicacao(id: number) {
    const url = this.routerService.serializeUrl(
      this.routerService.createUrlTree([`publicacao`], {
        queryParams: { id: id }
      })
    );
    window.open(url, '_blank');
  }

  private readonly showMessage = (text: string = '', errorMessage: boolean = false) => {
    this.apiStatus = errorMessage ? 'error' : 'success';
    this.message = text;
  };

  subscribeMessageService() {
    const subscription = this.messageService.errorData$.subscribe((errorData: ErrorData) => {
      this.showMessage(errorData.errorMessage, errorData.isError);
    });
    this.subscriptions.push(subscription);
  }

  formataData(data: number) {
    return this.datePipe.transform(new Date(data), 'dd/MM/yyyy');
  }

  isDestaque(destaque: number) {
    if (destaque > 0) {
      return 'red';
    } else {
      return '';
    }
  }

  getTermoPremmiar() {
    this.publicacaoService.primeiraAceitavel(29).subscribe({
      next: (resp) => {
        if (resp && resp.id) {
          const dataFinal = new Date(resp.dataFinal);
          const dataInicial = new Date(resp.dataInicial);
          const dataAtual = getDateBrasil();

          if (dataAtual >= dataInicial && dataAtual <= dataFinal) {
            this.idPublicacaoTermoPremmiar = resp.id;
            this.showTermoFidelidadePremmiar = true;
          }
        }
      }
    });
  }

  getOfertas(idCanais: number, flagComCondicaoDeAceite: string, flagParaTodosDoGrupo: string) {
    this.publicacaoService.getConfiguracoesOferta([idCanais], flagComCondicaoDeAceite, flagParaTodosDoGrupo).subscribe({
      next: (response) => {
        if (response.length > 0) this.configuracoesOfertaImagem = [response[0]];
      }
    });
  }
}
